export default __webpack_public_path__ + "static/fXeDsqXN-6ccae493084c78eb9559168e26aa0027.svg";